export default "__VITE_ASSET__DoHqBlQz__"